export default function authHeader() {
  const stored = localStorage.getItem("user_free");
  const token = stored ? JSON.parse(stored).token : null;

  if (token) {
    return {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
  }

  return {};
}
